import React from "react";
import { Link } from "react-router-dom";

const News1 = () => {
  /* --- quick inline style objects --- */
  const box = {
    border: "1px solid #d9e2ea",
    borderRadius: "2px",
    padding: "0 16px 8px",
    fontFamily: "Arial, sans‑serif",
    fontSize: "15px",
    lineHeight: "1.5",
    color: "#000",
    marginTop: "16px",
  };

  const title = {
    fontWeight: "700",
    fontSize: "22px",
    padding: "12px 0 8px",
    margin: "0",
    borderBottom: "1px solid #d9e2ea",
  };

  const table = { width: "100%", borderCollapse: "collapse" };

  const th = {
    width: "230px",
    color: "#064f9e", // same deep blue as screenshot
    fontWeight: "600",
    padding: "8px 0",
    verticalAlign: "top",
    borderBottom: "1px solid #d9e2ea",
  };

  const td = {
    padding: "8px 0",
    borderBottom: "1px solid #d9e2ea",
    verticalAlign: "top",
  };

  const list = { margin: 0, paddingLeft: "18px" };

  return (
    <>
      <div className="dlab-post-meta">
        <ul>
          <li className="post-date">
            {" "}
            <strong>30 Apr</strong> <span> 2025</span>{" "}
          </li>
          <li className="post-author">
            {" "}
            By <Link to="/#">Uuganbold</Link>{" "}
          </li>
        </ul>
      </div>
      <div style={box}>
        <h2 style={title}>Хувьцаа эзэмшигчдийн хурлын шийдвэр / Эм Эн Ди ХК</h2>

        <table style={table}>
          <tbody>
            <tr>
              <td style={th}>
                Хувьцаа эзэмшигчдийн
                <br />
                хурлын мэдэгдэл:
              </td>
              <td style={td}>Ээлжит</td>
            </tr>

            <tr>
              <td style={th}>Хуралдсан огноо:</td>
              <td style={td}>2025‑04‑30  11:00 цагт</td>
            </tr>

            <tr>
              <td style={th}>
                Хуралдсан
                <br />
                газар:
              </td>
              <td style={td}>
                Улаанбаатар хот, Хан‑Уул дүүрэг 15‑р хороо, Стадион
                оргил /17010/ Чингисийн өргөн чөлөө гудамж
                Кэй би тауэр 2 давхарт 203 тоотод
              </td>
            </tr>

            <tr>
              <td style={th}>Хурлын ирц:</td>
              <td style={td}>67 %</td>
            </tr>

            <tr>
              <td style={th}>
                Хувьцаа эзэмшигчдийн
                <br />
                хурлын шийдвэр
              </td>
              <td style={td}>
                <ul style={list}>
                  <li>
                    Компанийн 2024 оны үйл ажиллагааны болон санхүүгийн тайланд
                    өгөх Төлөөлөн удирдах зөвлөлийн гаргасан дүгнэлтийг хэлэлцэж
                    батлах
                  </li>
                  <li>
                    Компанийн дүрэмд нэмэлт, өөрчлөлт оруулах тухай асуудлыг
                    хэлэлцэн батлах
                  </li>
                  <li>
                    Компанийн ноогдол ашиг тараахгүй байх ТУЗ‑ийн гаргасан
                    тогтоолыг танилцуулах
                  </li>
                  <li>
                    ТУЗ‑ийн бүрэн эрхийг бүрэн бүрэлдэхүүнээр нь дуусгавар
                    болгож, ТУЗ‑ийн гишүүдийг кумулятив аргаар сонгох тухай
                  </li>
                  <li>
                    ТУЗ‑ийн гишүүдийн цалин, урамшууллын хэмжээг тогтоох тухай
                  </li>
                </ul>

                <div style={{ marginTop: "8px" }}>
                  <span style={{ marginRight: "24px" }}>
                    <strong>Зөвшөөрсөн:</strong> 100
                  </span>
                  <span style={{ marginRight: "24px" }}>
                    <strong>Татгалзсан:</strong> 0
                  </span>
                  <span>
                    <strong>Түтгэлзсэн:</strong> 0
                  </span>
                </div>
              </td>
            </tr>

            <tr>
              <td style={th}>
                Шийдвэрийн
                <br />
                тогтоолууд:
              </td>
              <td style={td}>
                <a
                  href="https://mse.mn/issuers/shiidber/118_2025-04-30%2011:00hnh_togtool1990847743.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#064f9e", textDecoration: "underline" }}
                >
                  Татаж авах
                </a>
              </td>
            </tr>

            <tr>
              <td style={th}>
                Бусад хэлэлцсэн
                <br />
                асуудал:
              </td>
              <td style={td}>
                <ul style={list}>
                  <li>
                    Компанийн 2024 оны үйл ажиллагааны болон санхүүгийн тайланд
                    өгөх Төлөөлөн удирдах зөвлөлийн гаргасан дүгнэлтийг хэлэлцэж
                    батлах
                  </li>
                  <li>
                    Компанийн дүрэмд нэмэлт, өөрчлөлт оруулах тухай асуудлыг
                    хэлэлцэн батлах
                  </li>
                  <li>
                    Компанийн ноогдол ашиг тараахгүй байх ТУЗ‑ийн гаргасан
                    тогтоолыг танилцуулах
                  </li>
                  <li>
                    ТУЗ‑ийн бүрэн эрхийг бүрэн бүрэлдэхүүнээр нь дуусгавар
                    болгож, ТУЗ‑ийн гишүүдийг кумулятив аргаар сонгох тухай
                  </li>
                  <li>
                    ТУЗ‑ийн гишүүдийн цалин, урамшууллын хэмжээг тогтоох тухай
                  </li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
};

export default News1;
